/**
 * Sleeps for a specified amount of milliseconds.
 *
 * @param {Number} ms - Amount of milliseconds to sleep.
 * @returns {Promise<any>}
 */
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export default sleep;
